export default "__VITE_ASSET__Dl_$2_M0__"